import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  clearFavouriteGames,
  clearLastPlayedGames,
  getFavouriteGames,
  getGames,
  getGamesJackpots,
  getLastPlayedGames,
} from '@/store/games/actions';
import { selectUser } from '@/store/selectors/userSelectors';
import { selectLocale } from '@/store/selectors/commonSelectors';
import { isEmpty } from '@/shared/utility';

// this Hook is to be used in the DataLoader only
// it handles all the logic for when the games need to be refreshed
const useGamesLoader = (): void => {
  const user = useSelector(selectUser);
  const locale = useSelector(selectLocale);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!locale) {
      return;
    }
    // we want to trigger getGames only once when the app loads
    dispatch(getGames());
    dispatch(getGamesJackpots());
  }, [locale]);

  useEffect(() => {
    // we want to trigger getLastPlayedGames when the user changes, and clear last played games if user doesn't exist
    if (!isEmpty(user)) {
      dispatch(getLastPlayedGames());
      dispatch(getFavouriteGames());
    } else {
      dispatch(clearLastPlayedGames());
      dispatch(clearFavouriteGames());
    }
  }, [user]);
};

export default useGamesLoader;
